<template>
  <div :class="$style.column">
    <MenuButton v-if="showMenuButton" />

    <slot />

    <NavigationIconItem
      v-for="navigationItem in navigationItems"
      :key="navigationItem.id"
      :render-horizontally="renderHorizontally"
      v-bind="navigationItem"
    />
  </div>
</template>

<script>
import MenuButton from '@/js/components/Navigation/MenuButton.vue'
import NavigationIconItem from '@/js/components/Navigation/NavigationIconItem.vue'

export default {
  name: 'TopNavigationMenu',
  components: {
    MenuButton,
    NavigationIconItem,
  },
  props: {
    navigationItems: {
      type: Array,
      default: () => [],
    },
    showMenuButton: {
      type: Boolean,
      default: true,
    },
    renderHorizontally: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" module>
.column {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.75rem 1rem;
}
</style>
